import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ConfirmDialogComponent } from 'src/app/@shared/components/confirm-dialog/confirm-dialog.component'
import { LeaveConfirmService } from './leave-confirm.service'

/** Diálogo de sair com alterações não salvas (pedido pela guarda de rota). */
@Component({
  selector: 'app-leave-confirm',
  standalone: true,
  imports: [ConfirmDialogComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (service.request(); as request) {
      <app-confirm-dialog
        data-testid="leave-confirm"
        [title]="'shared.leaveConfirm.title' | translate"
        [message]="request.key | translate"
        [confirmLabel]="'shared.leaveConfirm.leave' | translate"
        [cancelLabel]="'shared.leaveConfirm.stay' | translate"
        (confirm)="service.answer(true)"
        (cancel)="service.answer(false)"
      />
    }
  `
})
export class LeaveConfirmComponent {
  readonly service = inject(LeaveConfirmService)
}
